import React from 'react';

import { Button as CoreButton, Modal as CoreModal } from '../../..';

import { StyledBasicPopUp } from './BasicPopUp.styles';
import { BasicPopUpProps } from './BasicPopUp.types';

const BasicPopUp = ({
  modalComponent: Modal = CoreModal,
  buttonComponent: Button = CoreButton,
  titleSlot,
  children,
  buttonPropsList,
  componentClassname = 'basic-pop-up',
  customClassnames = '',
  customStyle = '',
  ...props
}: BasicPopUpProps) => {
  return (
    <StyledBasicPopUp
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      <Modal {...props}>
        <div className={`${componentClassname}__inner-wrapper`}>
          {titleSlot && (
            <div className={`${componentClassname}__title`}>{titleSlot}</div>
          )}

          <div className={`${componentClassname}__content`}>{children}</div>

          {buttonPropsList?.length > 0 && (
            <div className={`${componentClassname}__button-list`}>
              {buttonPropsList?.map((buttonProps, index) => (
                <Button key={index} {...buttonProps} />
              ))}
            </div>
          )}
        </div>
      </Modal>
    </StyledBasicPopUp>
  );
};
BasicPopUp.displayName = 'BasicPopUp';

export default BasicPopUp;
